<template>
  <div v-if="alerts.length" :class="{ adjustMarginForHeader:hasHeader && isAnyAlertsShown }">
    <template v-for="alert in alerts">
      <v-alert
        v-if="alert.isShown"
        :key="alert.hash"
        dismissible
        :type="alert.type"
        :value="true"
        @input="handleAlertDismissal(alert.hash)"
        style="text-align:center"
      >
        {{ alert.message }}
      </v-alert>
    </template>
  </div>
</template>

<script>
import env from 'env-service'

export default {
  name: 'SystemAlerts',
  props: {
    hasHeader: {
      type: Boolean,
    },
  },
  data() {
    return {
      rawSystemAlertData: {},
      dismissedAlerts: [],
      alerts: [],
    }
  },
  computed: {
    isAnyAlertsShown(){
      return this.alerts.some( a => a.isShown )
    }
  },
  watch: {
    // Update local storage immediately when user dismisses an alert
    dismissedAlerts() {
      localStorage.setItem('dismissedSystemAlerts', JSON.stringify(this.dismissedAlerts))
    },
  },
  beforeMount() {
    this.fetchSystemAlerts()
    // Get list of dismissed alerts from local storage (array of message hashes)
    this.dismissedAlerts = JSON.parse(localStorage.getItem('dismissedSystemAlerts') || '[]')
  },
  methods: {
    fetchSystemAlerts() {
      // Get latest alerts from Google Sheets
      // https://sheets.googleapis.com/v4/spreadsheets/[worksheet_id]/values/[tab_name]![rangestart:rangeend]?alt=json&key=[apiKey]
      const googleSheetSource = env.IS_PRODUCTION_CONNECTION
        ? 'https://sheets.googleapis.com/v4/spreadsheets/1O0ictzZqm3HJdPJ87moy3LHZtjFlrZpbyLZdGD4nGF8/values/Current!A2:AA984?alt=json&key=AIzaSyCvpGUkUGcU_twQRdU49gEtrbM683URGwg'
        : 'https://sheets.googleapis.com/v4/spreadsheets/1XGFl9cpmGMPpz9fEhlCU07hRbuSsqBt5SmSs96l50Wc/values/STAGING!A2:AA984?alt=json&key=AIzaSyCvpGUkUGcU_twQRdU49gEtrbM683URGwg'
      fetch(googleSheetSource)
        .then(r => r.json())
        .then(r => {
          this.rawSystemAlertData = r
          this.alerts = this.getAlerts()
        })
        .catch(e => {
          console.error(e)
        })
    },
    handleAlertDismissal(h) {
      this.dismissedAlerts.push(h)
      this.guibus_publish('dismiss:systemAlert')
    },
    getAlerts() {
      return (
        this.rawSystemAlertData &&
        this.rawSystemAlertData.values &&
        this.rawSystemAlertData.values.map(e => {
          const hash = _stringToHash(e.join(''))
          return {
            date: e[0],
            isShown: e[2].toLowerCase() == 'true' && !this.dismissedAlerts.includes(hash),
            type: e[3],
            message: e[4],
            hash: hash,
          }
        })
      )
    },
  },
}

// https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
function _stringToHash(str) {
  let hash = 0,
    i,
    chr
  if (str.length === 0) return hash
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i)
    hash = (hash << 5) - hash + chr
    hash |= 0 // Convert to 32bit integer
  }
  return hash
}
</script>

<style scoped>
/*
  If Header FEMS (which is fixed) is present on a page where we are displaying system alerts then
  adjust margins of system alerts to accommodate
*/
.adjustMarginForHeader {
  margin: 55px 0 -55px 0;
}
</style>
